"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGreaterThan = void 0;
exports.isGreaterThan = (a, b) => a > b;
//# sourceMappingURL=is-greater-than.js.map